<div class="row">
    @for(topcard of topcards; track topcard.color) {
    <div class=" col-sm-4 col-6" >
        <mat-card class="shadow-none text-center bg-light-{{ topcard.color }}  shadow-none">
            <mat-card-content >
                <h4 class="mat-subtitle-2 f-w-600 text-{{ topcard.color }} m-t-8">
                    {{ topcard.title }}
                </h4>
                <h6 class="m-t-4 mat-subtitle-1 f-w-600 text-{{ topcard.color }} m-t-8">
                    <ng-container *ngIf="!isLoading; else loading">
                      {{ topcard.subtitle }}
                    </ng-container>
                  </h6>
            </mat-card-content>
        </mat-card>
    </div>
    }
</div>


<app-table-standard-layout [dataSource$]="companies$" [title]="'Orders'"  [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton" [columnSettings]="columnSettings" ></app-table-standard-layout>

<ng-template #loading>
    <div>Loading...</div>
  </ng-template>
